// The seven dimension keys dimension_feedback[].dimension carries, in the
// wording a student reads. Same pattern as TARA_TRAIT_LABELS: used only when
// a label is not otherwise supplied, so an unfamiliar key still renders as
// something readable rather than a blank row or a raw snake_case string.

export const LNAT_DIMENSION_LABELS = {
  proportionality_reasoning: 'Proportionality reasoning',
  hidden_tension_detection: 'Hidden tension detection',
  second_order_reasoning: 'Second-order reasoning',
  qualified_synthesis: 'Qualified synthesis',
  stakeholder_balancing: 'Stakeholder balancing',
  clarity_and_structure: 'Clarity and structure',
  factual_knowledge: 'Factual knowledge',
};

export function lnatDimensionLabel(dimension) {
  return LNAT_DIMENSION_LABELS[String(dimension || '').trim().toLowerCase()]
    || String(dimension || '').replace(/_/g, ' ');
}
